/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from "react";
import * as Sentry from "@sentry/react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
    Sentry.captureException(error, { contexts: { react: { componentStack: info?.componentStack } } });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          padding: 24, fontFamily: "'DM Sans', system-ui, sans-serif",
          background: "#FAFAFA",
        }}>
          <div style={{ maxWidth: 340, textAlign: "center" }}>
            <div style={{
              width: 56, height: 56, borderRadius: 16, background: "var(--color-danger-light)",
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 16px", fontSize: 24,
            }}>
              !
            </div>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: "var(--color-text)", marginBottom: 8 }}>
              Something went wrong
            </h2>
            <p style={{ fontSize: 14, color: "var(--color-text-muted)", lineHeight: 1.5, marginBottom: 24 }}>
              An unexpected error occurred. Your data is safe — just tap below to get back on track.
            </p>
            <button
              onClick={() => { window.location.href = "/dashboard"; }}
              style={{
                width: "100%", padding: "14px 20px", borderRadius: 10,
                background: "var(--color-primary)", color: "var(--color-on-primary)", border: "none",
                cursor: "pointer", fontSize: 15, fontWeight: 600,
                fontFamily: "inherit", marginBottom: 10, minHeight: 48,
              }}
            >
              Back to Dashboard
            </button>
            <button
              onClick={() => { window.location.reload(); }}
              style={{
                width: "100%", padding: "10px 20px", borderRadius: 10,
                background: "none", color: "var(--color-text-muted)", border: "1px solid #E8E5EE",
                cursor: "pointer", fontSize: 13, fontWeight: 500,
                fontFamily: "inherit",
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
